<template>
    <div class="">
        <div v-bind:class="ContentBlockBaseProps.Class" v-bind:style="ContentBlockBaseProps.Style">
            <div :class="BlockProps.Shadow? 'shadow-sm mb-3' : ''" :style="{'background-color' : BlockProps.BGColor + ' !important'}">
                <div class="container" v-bind:style="ContainerPadding">
                    <!-- Heading -->
                    <div class="w-lg-65 text-center mx-lg-auto mb-4">
                        <omnieditor :iseditmode="iseditmode" editortype="tinymce" keyDown v-model="BlockProps.Header" tag-name="h2" :init="EditorConfig" />
                        <omnieditor :iseditmode="iseditmode" editortype="tinymce" keyDown v-model="BlockProps.Leadin" :init="EditorConfig" />
                    </div>
                    <!-- End Heading -->

                    <div class="w-lg-65 mx-lg-auto mb-0">
                        <div class="row row-cols-2 row-cols-sm-3 justify-content-center">

                            <div class="col" v-for="nug in BlockProps.Nuggets">
                                <!-- Icon Block -->
                                <div class="text-center">
                                    <div class="mb-3">
                                        <propertyiconeditor :inline="true" v-model:icon="nug.Icon" :prompt="'Header Icon (click to change)'"></propertyiconeditor>
                                    </div>
                                    <omnieditor :iseditmode="iseditmode" editortype="tinymce" keyDown v-model="nug.Title" tag-name="h5" :init="EditorConfig" />
                                    <omnieditor :iseditmode="iseditmode" editortype="tinymce" keyDown v-model="nug.SubTitle" tag-name="span" :init="EditorConfig" />
                                </div>
                                <!-- End Icon Block -->
                            </div>
                            <!-- End Col -->

                        </div>
                        <!-- End Row -->
                    </div>

                    <!-- End Row -->
                </div>
            </div>

        </div>

        <div v-if="iseditmode" style="z-index:300" class="modal" :id="'editor' + BlockProps.UId" tabindex="-1" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Options</h5>
                    </div>
                    <div class="modal-body">
                        <hr style="margin: 0px; margin-bottom:10px;" />
                        <propertybaseeditors :blockprops="BlockProps" :additionalcfg="AdditionalCfg"></propertybaseeditors>
                        <div class="row">
                            <hr style="margin-top: 10px; margin-bottom:5px;" />
                            <div class="col col-12">
                                <label for="customRange2" class="form-label">Number of Nuggets (1 - 6)</label>
                                <div class="input-group mb-3">
                                    <button @click="RemoveNugget" class="btn btn-outline-secondary" type="button">-</button>
                                    <input readonly style="text-align:center;" min="1" max="6" type="number" class="form-control" v-model="NumNuggetsUI">
                                    <button @click="AddNugget" class="btn btn-outline-secondary" type="button">+</button>
                                </div>
                                <div class="progress" style="height: 20px;">
                                    <div class="progress-bar" role="progressbar" :style="{'width': NumNuggetsUIFilled}" :aria-valuenow="NumNuggetsUIFilled" aria-valuemin="0" aria-valuemax="6">{{NumNuggetsUI}} / 6</div>
                                </div>
                            </div>
                            

                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal">Done</button>
                        <!--<button type="button" class="btn btn-sm btn-primary">Save changes</button>-->
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import EventHub from '/src/Util/EventHub.js';
    import ContentBlockBase from '/src/components/ContentCreator/ContentBlockBase.vue'
    import { computed, ref, nextTick } from 'vue'


    export default {
        inheritAttrs: false,
        name: 'FeatureCloud',
        mixins: [ContentBlockBase],
        props: [],
        components: {

        },
        computed:
        {           
            NumNuggetsUIFilled() {
                return `${Math.floor(this.NumNuggetsUI / 6 * 100)}%`;
            }
        },
        data() {
            return {  
                NumNuggetsUI: 3
            };
        },
        watch: {
            NumNuggetsUI: function (newVal, oldVal) {

                while (newVal < this.BlockProps.Nuggets.length) {
                    this.BlockProps.Nuggets.pop();
                }

                while (newVal > this.BlockProps.Nuggets.length) {
                    var newNugget = JSON.stringify(this.Store.DefaultBlockProps[this.ComponentType].Nuggets[0]);
                    newNugget = JSON.parse(newNugget)
                    this.BlockProps.Nuggets.push(newNugget);
                }
            }
        },
        methods:
        {
            AddNugget: function () {
                this.NumNuggetsUI = Math.min(this.NumNuggetsUI + 1, 6);
            },
            RemoveNugget: function () {
                this.NumNuggetsUI = Math.max(this.NumNuggetsUI - 1, 1);
            },
            EditProperties: function () {
                var id = '#editor' + this.BlockProps.UId;
                var modalEl = document.querySelector(id);
                if (modalEl == null) {
                    return;
                }
                var modal = bootstrap.Modal.getOrCreateInstance(modalEl); // Returns a Bootstrap modal instance
                modal.show();
            },
            
        },

        setup(props, context)
        {             
            return {} // anything returned here will be available for the rest of the component
        },
        created()
        {           
            
        },
        beforeUnmount()
        {
            
        },
        mounted() {
            nextTick().then(() => {
         
            });
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>

